import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { ViewColumnComponent } from '../../../../../view-column.component';
import { SubSink } from 'subsink2';
import { BranchSettingsFacade } from '../../../facades/branch-settings.facade';
import { BranchSettingsSelectors } from '../../../branch-settings-controller/selectors';
import { BranchSettingsActions} from '../../../branch-settings-controller/actions';
import { BranchSettingsStates } from '../../../branch-settings-controller/states';
import { EMPTY, iif, of } from 'rxjs';
import { delay, mergeMap } from 'rxjs/operators';

interface LocalState {
  deactivateAdd: boolean;
  deactivateReturn: boolean;
  selectedIndex: number;
  deleteConfirmation: boolean;
}

@Component({
  selector: 'app-branch-printable-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentStore]
})

export class BranchPrintableEditComponent extends ViewColumnComponent {

  protected subs = new SubSink();

  protected compName = 'Create Pricing Scheme';
  protected index = 4;
  protected localState: LocalState;
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deleteConfirmation$ = this.componentStore.select(state => state.deleteConfirmation);

  guid;
  branchGuid;
  form: FormGroup;
  deleteConfirmation = false;
  @ViewChild(MatTabGroup) matTab: MatTabGroup;

  constructor(
    private branchSettingsStore: Store<BranchSettingsStates>,
    protected viewColFacade: BranchSettingsFacade,
    protected readonly componentStore: ComponentStore<LocalState>
    ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectBranch).subscribe(b=>{
      this.branchGuid = b.guid;
    })
    this.subs.sink = this.localState$.subscribe( a => {
      this.localState = a;
      this.componentStore.setState(a);
    });
    this.form = new FormGroup({
      printableFormatHdr: new FormControl(),
      priority: new FormControl(),
      header: new FormControl(),
      footer: new FormControl()
    })
    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectPrintable).subscribe(p=>{
      this.guid = p.guid;
      this.form.patchValue({
        printableFormatHdr: p.default_printable_format_guid,
	      priority: p.priority,
      	header: p.header,
      	footer: p.footer
      })
    })
    this.subs.sink = this.deleteConfirmation$.pipe(
      mergeMap(a => {
        return iif(() => a, of(a).pipe(delay(3000)), of(EMPTY));
      })
    ).subscribe(resolve => {
      if (resolve === true) {
        this.componentStore.patchState({deleteConfirmation: false});
        this.deleteConfirmation = false;
      }
    });
  }

  onReturn(){
    this.viewColFacade.onPrev(1);
  }

  onSave(){
    this.branchSettingsStore.dispatch(BranchSettingsActions.editBranchPrintableFormat({branchGuid: this.branchGuid,guid: this.guid, form: this.form.value}));
  }

  onDelete(){
    if (this.deleteConfirmation) {
      this.branchSettingsStore.dispatch(BranchSettingsActions.deleteBranchPrintableFormatInit({guid: this.guid}));
      this.deleteConfirmation = false;
      this.componentStore.patchState({deleteConfirmation: false});
    } else {
      this.deleteConfirmation = true;
      this.componentStore.patchState({deleteConfirmation: true});
    }
  }
}
